var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33464 3.89358V13.9967H14.8346V15.6805H2.33464C0.667969 15.6805 0.667969 13.9967 0.667969 13.9967V3.89358H2.33464ZM16.5013 2.20973V10.629H5.66797V2.20973H16.5013ZM16.7513 0.525879H5.41797C4.63463 0.525879 4.0013 1.11523 4.0013 1.83086V11.0078C4.0013 11.7319 4.63463 12.3128 5.41797 12.3128H16.7513C17.5346 12.3128 18.168 11.7319 18.168 11.0078V1.83086C18.168 1.11523 17.5346 0.525879 16.7513 0.525879ZM6.5013 3.05165H9.0013V7.26127H6.5013V3.05165ZM15.668 9.78705H6.5013V8.1032H15.668V9.78705ZM15.668 4.7355H10.668V3.05165H15.668V4.7355ZM15.668 7.26127H10.668V5.57743H15.668V7.26127Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticles);
export default __webpack_public_path__ + "static/media/articles.d92ba8a2.svg";
export { ForwardRef as ReactComponent };